import type React from 'react';
import { Box, Text, Secondary } from 'braid-design-system';
import { observer } from 'mobx-react';
import DateFormat from '../../../common/DateFormat';
import * as styles from '../PreviousApplications.css';
import type { Locale } from '@seek/melways-sites';
interface Props {
  date: string;
  children: React.ReactNode;
  locale: Locale;
}

const TimelineItem: React.FC<Props> = ({ date, children, locale }) => (
  <Box className={styles.timelineItem}>
    <Box marginBottom="small" className={styles.date}>
      <Text>
        <Secondary>
          <DateFormat date={date} locale={locale} />
        </Secondary>
      </Text>
    </Box>
    <Box marginBottom={['large', 'medium']}>{children}</Box>
  </Box>
);

export default observer(TimelineItem);
